import { render, staticRenderFns } from "./CommentsHistory.vue?vue&type=template&id=3b9f5de0&scoped=true"
import script from "./CommentsHistory.vue?vue&type=script&lang=js"
export * from "./CommentsHistory.vue?vue&type=script&lang=js"
import style0 from "./CommentsHistory.vue?vue&type=style&index=0&id=3b9f5de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9f5de0",
  null
  
)

export default component.exports